
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_jocwy_14pzr_5",
  "header": "awsui_header_jocwy_14pzr_6",
  "header-actions": "awsui_header-actions_jocwy_14pzr_7",
  "content": "awsui_content_jocwy_14pzr_8",
  "footer": "awsui_footer_jocwy_14pzr_9",
  "dismiss-button": "awsui_dismiss-button_jocwy_14pzr_10"
};
  